var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack527({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.08,12.06a3.72,3.72,0,0,0,.93.48l-.43.82a3.74,3.74,0,0,1-.51-.22l-.77-.51a3,3,0,0,1-1.25.25A2.74,2.74,0,0,1,6,12.1a3,3,0,0,1-.74-2.18A3,3,0,0,1,6,7.74,2.69,2.69,0,0,1,8,7a2.67,2.67,0,0,1,2,.78,3,3,0,0,1,.75,2.18,3.69,3.69,0,0,1-.21,1.3A2.63,2.63,0,0,1,10.08,12.06Zm-.93-.66a1.58,1.58,0,0,0,.33-.63,2.77,2.77,0,0,0,.12-.85,2.16,2.16,0,0,0-.44-1.48A1.45,1.45,0,0,0,8,8a1.44,1.44,0,0,0-1.14.49,2.13,2.13,0,0,0-.44,1.48,2.17,2.17,0,0,0,.44,1.5,1.42,1.42,0,0,0,1.11.5,1.45,1.45,0,0,0,.47-.08,2.8,2.8,0,0,0-.71-.36l.32-.66A4,4,0,0,1,9.15,11.4Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack527);
export default __webpack_public_path__ + "static/media/Symbolpack_5_27.accfcb5a4bb8d3c2ca33a8a9b3183658.svg";
export { ForwardRef as ReactComponent };